import {ChangeDetectionStrategy, Component, Inject, OnInit} from '@angular/core';
import {MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/legacy-dialog';
import {Router} from '@angular/router';
import {select, Store} from '@ngrx/store';
import {take} from 'rxjs/operators';
import * as fromRoot from '@core/redux';
import {LimitExceededResponse, PaymentType} from '@core/models/payment.model';

type Step = 'intro' | 'method' | 'expansion';

/**
 * Контейнер paywall — оркестрирует шаги: intro → method → requisites/expansion.
 * Не держит бизнес-логику (она в фасадах/вложенных компонентах), только стейт шагов.
 */
@Component({
  selector: 'paywall-modal',
  templateUrl: './paywall-modal.component.html',
  styleUrls: ['./paywall-modal.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaywallModalComponent implements OnInit {
  step: Step = 'intro';
  selectedMethod: PaymentType | null = null;

  constructor(
    private ref: MatDialogRef<PaywallModalComponent>,
    private router: Router,
    private store: Store<fromRoot.State>,
    @Inject(MAT_DIALOG_DATA) public data: LimitExceededResponse,
  ) {
  }

  ngOnInit(): void {
    // paymentMethodKnown = у владельца есть сохранённая карта (BillingInformation),
    // поэтому шаг выбора метода пропускаем сразу в оплату картой.
    if (this.data.upsell.type === 'expansion' && this.data.upsell.paymentMethodKnown) {
      this.step = 'expansion';
      this.selectedMethod = 'bank_card';
    }
  }

  get seatsWord(): string {
    const count = this.data.limit ?? 0;
    const mod10 = count % 10;
    const mod100 = count % 100;
    if (mod10 === 1 && mod100 !== 11) {
      return 'место';
    }
    if ([2, 3, 4].includes(mod10) && ![12, 13, 14].includes(mod100)) {
      return 'места';
    }
    return 'мест';
  }

  onMethodChosen(method: PaymentType): void {
    this.selectedMethod = method;
    // Шаг 'method' открывается только для upsell.type==='expansion' (см. onProceed),
    // поэтому всегда ведём на 'expansion' — builder сам разводит оплату картой/счётом.
    this.step = 'expansion';
  }

  onProceed(): void {
    if (this.data.upsell.type === 'upgrade') {
      this.store.pipe(select(fromRoot.getCompanyCurrentId), take(1)).subscribe(id => {
        this.ref.close();
        this.router.navigate(['/', id, 'payment']);
      });
    } else {
      this.step = 'method';
    }
  }

  onComplete(invoiceId: string): void {
    // paymentType нужен хосту: PDF счёта открываем только для безнала,
    // тестовая оплата уже применена testPay и документа не имеет.
    this.ref.close({invoiceId, paymentType: this.selectedMethod});
  }

  close(): void {
    this.ref.close();
  }
}
